import { useEffect, useState } from 'react';
import { InfrastructureByYearPerMonth } from '../../../types/types';

interface UseInfrastructureDataResult {
  infrastructureByYearPerMonth: InfrastructureByYearPerMonth | null;
  loading: boolean;
  error: string | null;
}

/**
 * Fetches infrastructure-destroyed data on mount — same pattern as
 * useEvictionsData. NEEDS CONFIRMATION: the endpoint path below is a
 * placeholder guess; swap it for the real route this data actually
 * comes from.
 */
export function useInfrastructureData(): UseInfrastructureDataResult {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [infrastructureByYearPerMonth, setInfrastructureByYearPerMonth] =
    useState<InfrastructureByYearPerMonth | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchInfrastructure = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await fetch(`${BASE_URL}/infrastructure/humanitarian/aggregate/`); // TODO: confirm real path
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }

        const data = await res.json();
        setInfrastructureByYearPerMonth(data);
      } catch (err) {
        console.error(err);
        setError(err instanceof Error ? err.message : 'Failed to load data');
      } finally {
        setLoading(false);
      }
    };

    fetchInfrastructure();
  }, []);

  return { infrastructureByYearPerMonth, loading, error };
}